import React, { useEffect } from "react"
import MainHeader from "../components/MainHeader"
import MainFooter from "../components/MainFooter"
import { categorizeURL } from "./analytics"

import "../styles/modern-normalize.css"
import "../styles/base.scss"
import "../styles/slick.min.css"

const wrapStyle = {
  display: 'grid',
  gridTemplateRows: 'auto 1fr auto',
  minHeight: '100vh'
}

const Layout = ({ children }) => {
  useEffect(() => {
    document.querySelectorAll('a').forEach(link => {
      const href = link.getAttribute('href')
      if (href.startsWith('http')) {
        link.setAttribute('target', '_blank')
        link.setAttribute('rel', 'noreferrer')
        link.dataset['linkoffCategory'] = categorizeURL(href)
      } else {
        link.classList.add('internal')
      }
      // TODO: jumplink hack
      if (href.startsWith('/#')) {
        link.addEventListener('click', e => {
          e.preventDefault()
          document.querySelector(href.slice(1)).scrollIntoView({ behavior: "smooth" })
        })
      }
    })
  })

  return (
    <div style={wrapStyle}>
      <MainHeader/>
      <main>
      { children &&
        children
      }
      </main>
      <MainFooter/>
    </div>
  )
}

export default Layout
